import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		text: {
			textAlign: ({ alignment }) => alignment?.metaValue || null,

			[theme.breakpoints.down('xs')]: {
				textAlign: ({ mobileAlignment }) => mobileAlignment?.metaValue || null,
			},
		},
	}),
	{ name: 'FAQ-FAQ1-Item' },
)

export default useStyles
